import {DeliveryOrderService} from 'src/app/features/transport-operation/services/delivery-order.service';
import {AddressMaintainanceService} from 'src/app/features/setting/service/address-maintainance.service';
import {DropdownOptionsService} from 'src/app/core/services/dropdown-options.service';
import {Component, Injector, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {PageInfo} from 'src/app/core/models/page-info';
import {SessionBaseComponent} from 'src/app/shared/components/session.base.component';
import {Table} from 'typeorm';
import {deepCopy, isNullOrEmpty} from 'src/app/core/utils/common-functions';
import {QueryOverDCRequest} from 'src/app/core/models/transport-operation/query-over-dc-request';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';

@Component({
  selector: 'laas-over-dc-search',
  templateUrl: './over-dc-search.component.html',
  styleUrls: ['./over-dc-search.component.scss']
})
export class OverDcSearchComponent extends SessionBaseComponent implements OnInit {

  readonly viewPermissionCode = PermissionConstants.OverDcSearch;
  @ViewChild('OverDcDataTable') dataTable!: Table;
  currentLang: string = this.laasSetting.language;
  isSearchFormOpen: boolean = true;
  isLoading: boolean = false;
  submitted: boolean = false;

  searchForm: FormGroup;
  searchParams: QueryOverDCRequest = new QueryOverDCRequest();

  brandOptions: any[] = []; // Dropdown options 品牌
  internalBrandOptions: any[] = [];
  consigneeKeyOption: any[] = []; // Dropdown options 客戶
  storerOption: any[] = []; // Dropdown options 貨主

  commonOption: any[];// 生效狀態

  pageInfo: PageInfo; // Table pagination information
  sortInfo: [{ property: string; direction: number }] | null; // Table sort information


  tableColumns: any[]; // Table 全部的欄位
  showTableColumns: any[]; // Table 顯示哪些欄位

  tableValue: any[] = []; // Table data

  selectedRowId: any; // Table selected row ID

  constructor(
      injector: Injector,
      private formBuilder: FormBuilder,
      private DropdownOptionsService: DropdownOptionsService,
      private AddressMaintainanceService: AddressMaintainanceService,
      private DeliveryOrderService: DeliveryOrderService
  ) {
    super(injector);

    this.tableColumns= [
      {field: 'erpStorer', header: 'OverDcSearch.Column.erpStorer', sort: 'true'},
      {field: 'consigneeKey', header: 'OverDcSearch.Column.consigneeKey', sort: 'true'},
      {field: 'customerName', header: 'OverDcSearch.Column.customerName', sort: false},
      {field: 'brand', header: 'OverDcSearch.Column.brand', sort: 'true'},
      {field: 'internalBrand', header: 'OverDcSearch.Column.internalBrand', sort: 'true'},
      {field: 'sku', header: 'OverDcSearch.Column.sku', sort: 'true'},
      {field: 'activeFlag', header: 'OverDcSearch.Column.activeFlag', sort: 'true'},
      {field: 'descr', header: 'OverDcSearch.Column.overDc', sort: 'true'},
      {field: 'startDate', header: 'OverDcSearch.Column.effectiveDt', dataType: 'date', sort: 'true'},
      {field: 'endDate', header: 'OverDcSearch.Column.expirationDt', dataType: 'date', sort: 'true'},
      {field: 'creationDate', header: 'OverDcSearch.Column.createDt', dataType: 'date', sort: 'true'},
      {field: 'createdBy', header: 'OverDcSearch.Column.creater', sort: 'true'},
      {field: 'lastUpdateDate', header: 'OverDcSearch.Column.lastUpdateDt', dataType: 'date', sort: 'true'},
      {field: 'lastUpdatedBy', header: 'OverDcSearch.Column.lastUpdater', sort: 'true'},
    ]

    // Table 顯示哪些欄位
    this.showTableColumns = this.tableColumns;

    // Form control of query
    this.searchForm = this.formBuilder.group({
      brand: [],
      internalBrand: [],
      erpStorer: [null, Validators.required],
      sku: null,
      consigneeKey: [],
      activeFlag: null,
    })

    // Table pagination information
    this.pageInfo = {
      pageSize: 5,
      pageIndex: 0,
      totalRecords: 0,
      totalPages: 0,
    };

    this.sortInfo = null;
    this.commonOption = [
      { label: 'All', value: null },
      { label: 'Y', value: 'Y' },
      { label: 'N', value: 'N' }
    ];

  }



  async ngOnInit(): Promise<void>{

    // Dropdown options 品牌
    this.DropdownOptionsService.getBrandOptions(1).subscribe({
      next: (options: any[]) => {
        this.brandOptions = options.map(x => ({
          label: x.brandName,
          value: x.brandName
        }));
        this.brandOptions.unshift({ label: 'ALL', value: 'ALL' });
        this.internalBrandOptions = this.brandOptions;
      }
    });

    this.AddressMaintainanceService.getCustomerOptions().subscribe({
      next: (result) => {
        this.consigneeKeyOption = [...result].map((x: any) => {
          return {
            label: `${x.customerCode} - ${x.customerName}`,
            value: x.customerCode,
          };
        });
        this.consigneeKeyOption.unshift({ label: 'ALL', value: 'ALL' });
      },
    });

    this.AddressMaintainanceService.getStorerOptions().subscribe({
      next: (result) => {
        this.storerOption = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}`,
            value: x.optionCode,
          };
        });
        if (this.storerOption.length > 0) {
          this.storerOption.sort((a, b) => a.label.localeCompare(b.label));
        }
      },
    });

  }

  /**
   * DO number field add event.
   * @param event p-chips onAdd event.
   */
  chipsAdd(event: any, fromControlName: any): void {
    const value: string = event.value;
    const parsedValues: string[] = value.split('\r\n').filter(x => isNullOrEmpty(x) === false && x !== '\r\n');
    const formControl = this.searchForm.get(fromControlName);
    formControl?.value.splice(formControl?.value.indexOf(value));
    const parsedValuesUpper = parsedValues.map(x => x.toUpperCase());
    formControl?.setValue(formControl?.value.concat(parsedValuesUpper));
  }

  /**
   * 將每行資料加上 row ID 以便識別，且 row ID 其實就是 array index
   *
   * @param array
   */
  putRowId(array: any[]) {
    let rowId = 0;
    for (const val of array) {
      val.rowId = rowId;
      rowId = rowId + 1;
    }
  }

  /**
   * Get table 顯示哪些欄位
   */
  get selectedColumns(): any[] {
    return this.showTableColumns;
  }

  /**
   * Set table 顯示哪些欄位
   */
  set selectedColumns(cols: any[]) {
    this.showTableColumns = this.tableColumns.filter(col => cols.includes(col));
  }

  /**
   * Get select row of table
   */
  get selectRow(): any {
    if (isNullOrEmpty(this.selectedRowId)) {
      return null;
    }
    return this.tableValue[this.selectedRowId];
  }

  /**
   * Set select row of table
   */
  set selectRow(rowData: any) {

    // 這支程式只承認 selected, 不承認 unselected
    if (isNullOrEmpty(rowData)) {
      return;
    }

    // 若原本就是 null or undefined, 則只需接值即可.
    if (isNullOrEmpty(this.selectedRowId)) {
      this.selectedRowId = rowData.rowId;
      return;
    }

    // 若 selected 同一行，不用做任何事
    if (this.selectedRowId == rowData.rowId) {
      return;
    }

    this.selectedRowId = rowData.rowId;
  }

  /**
   * Button 查詢
   *
   * @param event
   */
  searchBtnClick(event: any) {
    this.pageInfo.pageIndex = 0;
    if (this.searchForm.invalid) {
      this.submitted = true;
      this.toastService.warn(this.translateService.instant('ReceiptFormQuery.Alert.CheckRequired'));
      return;
    }
    this.requestOfQuery();
  }

  /**
   * Button 匯出
   *
   * @param event
   */
  exportBtnClick(event: any): void {
    if (this.searchForm.invalid) {
      this.submitted = true;
      this.toastService.warn(this.translateService.instant('ReceiptFormQuery.Alert.CheckRequired'));
      return;
    }
    this.requestOfQuery(false);
  }

  /**
   * Table 換頁
   *
   * @param event
   */
  tablePageChange(event: any) {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.requestOfQuery();
  }

  /**
   * Table 排序
   *
   * @param event
   */
  tableSort(event: any): void {
    this.sortInfo = [{ property: event.field, direction: event.order }];
    this.requestOfQuery();
  }

  async setPageSize(event: any): Promise<void>{
    this.pageInfo.pageSize = event.rows;
  }

  /**
   * HTTP request of query
   *
   * @param isQuery
   * @returns
   */
  requestOfQuery(isQuery: boolean = true) {
    this.searchParams = deepCopy(this.searchForm.value);
    this.searchParams.activeFlag = this.searchForm.value.activeFlag?.value;
    // Pagination information
    this.searchParams.pageSize = this.pageInfo.pageSize;
    this.searchParams.pageIndex = this.pageInfo.pageIndex;
    this.searchParams.sortInfo = this.sortInfo;
    this.searchParams.language = this.laasSetting.language

    this.isLoading = true;

    if (isQuery) {

      // Clear selected row ID
      this.selectedRowId = undefined;

      this.DeliveryOrderService.QueryOverDC(this.searchParams)
          .subscribe({
            next: (result) => {
              const isSuccess = result.flag;

              if (!isSuccess) {
                this.toastErrorMessage(result.message);

                this.tableValue = [];
                this.pageInfo = {
                  pageSize: 5,
                  pageIndex: 0,
                  totalRecords: 0,
                  totalPages: 0,
                };

                return;
              }

              // 共 ? 筆
              this.pageInfo.totalRecords = result.totalRecords;

              // Get data
              const overDCDatas = result.overDCs;
              this.tableValue = overDCDatas.map((x: any) => {
                if (x.companyC && x.companyE) {
                  x.customerName = x.companyC + '\n' + x.companyE;
                } else {
                  x.customerName = x.companyC || x.companyE || 'ALL';
                }
                return x;
              });

              // Initial table value and put row ID
              this.putRowId(this.tableValue);
            },
            error: (err) => {
              this.toastErrorMessage(err.error);

              this.tableValue = [];
              this.pageInfo = {
                pageSize: 5,
                pageIndex: 0,
                totalRecords: 0,
                totalPages: 0,
              };
            },
            complete: () => {
              this.isLoading = false;
              this.isSearchFormOpen = false;
            }
          });

    } else {
      this.downloadExcel(this.searchParams);
    }
  }


  /**
   * 下載 Data Excel 檔案
   *
   * @param excelOverDcDatas
   */
  downloadExcel(searchParams: any): void {
    this.DeliveryOrderService.exportOverDcData(searchParams).subscribe(result => {

      if (result == null || result.size == 0) {
        this.translateService.get('Common.Toast.NoData').subscribe({
          next: i18nResult => {
            this.toastService.info(i18nResult);
          }
        });
        this.loader.hide();
        this.isLoading = false;
        return;
      }

      let downloadURL = window.URL.createObjectURL(result);
      let link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'OverDC Result.xlsx'
      link.click();
      this.isLoading = false;
    });
  }

}





